module.exports = __webpack_public_path__ + "static/img/company_introduce_2.26527d80.jpg";